import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IMiscellaneousPeriodicCostsFormMeta {
    idBank: FormInputMeta;
    nameBank: FormInputMeta;
    idFees: FormInputMeta;
    nameFees: FormInputMeta;
    amount: FormInputMeta;
    periodicity: FormInputMeta;
    
    schema: any;
  }

const MiscellaneousPeriodicCostsFormMeta = {} as IMiscellaneousPeriodicCostsFormMeta;

MiscellaneousPeriodicCostsFormMeta.idBank = {
    name: "idBank",
    label: "ID Banque",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
MiscellaneousPeriodicCostsFormMeta.nameBank = {
    name: "nameBank",
    label: "Raison Sociale",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
MiscellaneousPeriodicCostsFormMeta.idFees = {
    name: "idFees",
    label: "ID Frais",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
MiscellaneousPeriodicCostsFormMeta.nameFees = {
    name: "nameFees",
    label: "Nom Frais",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
MiscellaneousPeriodicCostsFormMeta.amount = {
    name: "amount",
    label: "Montant",
    type: "number",
    validation: yup.string().required("Ce champ est requis"),
}
MiscellaneousPeriodicCostsFormMeta.periodicity = {
    name: "periodicity",
    label: "Periodicité",
    type: 'select',
    placeholder: 'Select ...',
    options:  [
      {
        label: 'Journalier',
        value: 'a'
      },
      {
        label: 'Hebdomadaire',
        value: 'b',
      },
      {
        label: 'Mensuel',
        value: 'b',
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
}



MiscellaneousPeriodicCostsFormMeta.schema = yup.object().shape(getValidationSchema(MiscellaneousPeriodicCostsFormMeta));

export default MiscellaneousPeriodicCostsFormMeta;